import React, { useCallback, useState } from 'react';
// import Routes from '../../../../routes/routes';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import * as S from './style';
import { CTAOfferButton } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import Image from '../../../components/loggedout/common/Image';

import CartoonImg from "~images/oddbods/cartoons.png";
import CartoonImgDesktop from "~images/oddbods/cartoon_desk.png";

import StarImg from "~images/oddbods/star.svg"
import KidSafeLogo from "~images/sem/kid_safe_coppa.svg";
import WhiteWave from "~images/sem/wave-white.png";

import { deepCoveDark, white } from '../../../components/loggedout/shared-styles/Colors';
import { breakpoints } from '../../../utils/responsive_utilities';
// import { PARENT_SIGNUP_PATH } from '../../../routes/route-paths';


const FirstFold = ({btnClickEvent, ctaText, urlToRedirect }) => {
  // let ctaText = 'Sign up for free';

  const getStars = useCallback(() => {
    let starArray = [];
    for (let i = 0; i < 6; i++)
      starArray.push(<S.Star key={i}><Image src={StarImg} /></S.Star>);
    return starArray;
  }, [])

  return (
    <S.ContainerWrapper>
      <S.StarContainer>
        {getStars()}
      </S.StarContainer>

      <S.ContentWrapper>
        <S.LeftContainer>
          <S.HeadingText>Your favorite Oddbods are now on SplashLearn!</S.HeadingText>
          <S.SubHeadingText color={white} textAlign='left' fontWeight={4}> Say hello to fun, learning, and play - all in one place.</S.SubHeadingText>
          <S.ButtonWrapper>
            <CTAOfferButton white={true} textColor={deepCoveDark} fontWeight="600" hoverColor="rgb(237, 237, 249)">
              <a href={urlToRedirect} onClick={btnClickEvent}>
                {ctaText}
              </a>
            </CTAOfferButton>
          </S.ButtonWrapper>
        </S.LeftContainer>
        <S.RightContainer>
          <S.ImgSection>
            <MediaQuery query={`(min-width: ${breakpoints.xl}px)`}>
            <Image alt="image" src={CartoonImgDesktop} />
            </MediaQuery>
            <MediaQuery query={`(max-width: ${breakpoints.xl}px)`}>
            <Image alt="image" src={CartoonImg} />
            </MediaQuery>
          </S.ImgSection>
        </S.RightContainer>
      </S.ContentWrapper>
      <S.BottomWave>

        <Image alt="image" src={WhiteWave} />
        <S.BottomSection>
          <S.KidSafe>
            <Image alt="image" src={KidSafeLogo} />
          </S.KidSafe>
          <S.BottomHeadingText> Trusted by millions</S.BottomHeadingText>
          <S.SubHeadingText>Over 40+ million children and 750,000 teachers love SplashLearn</S.SubHeadingText>
        </S.BottomSection>
      </S.BottomWave>
    </S.ContainerWrapper>
  )
}

export default FirstFold;